import { ThemeOptions } from '@material-ui/core/styles/createTheme';

export const arabiaTheme: ThemeOptions = {
  palette: {
    primary: {
      main: '#986727',
    },
    secondary: {
      main: '#44749d',
    },
    /**
     * @todo add tertiary do cliente
     */
    tertiary: {
      main: '#E2E543',
    },
    additionalColors: {
      promoHighligts: '#986727',
    },
  },
};
